/**
 * The two halves of the Posteingang (PRD #1453).
 *
 * A notification is in exactly one of them, decided by a single nullable
 * timestamp on the row: unset means it still awaits the recipient (`OPEN`), set
 * means it is finished (`ARCHIVED`). The lanes are therefore complements by
 * construction — there is no third state to fall into and no way to be in both.
 *
 * The values are the English identifiers the wire carries; the German the user
 * reads ("Offen", "Archiv") lives in the frontend alone.
 */
export var NotificationLane;
(function (NotificationLane) {
    NotificationLane["OPEN"] = "open";
    NotificationLane["ARCHIVED"] = "archived";
})(NotificationLane || (NotificationLane = {}));
//# sourceMappingURL=notification-lane.enum.js.map